export var LayoutStatusType;
(function (LayoutStatusType) {
    LayoutStatusType["CAN_APPLY"] = "can_apply";
    LayoutStatusType["APPLIED"] = "applied";
    LayoutStatusType["CANNOT_APPLY"] = "cannot_apply";
    LayoutStatusType["APPLIED_AND_PENDING"] = "applied_and_pending";
})(LayoutStatusType || (LayoutStatusType = {}));
export var LayoutStatusApplyButtonText;
(function (LayoutStatusApplyButtonText) {
    LayoutStatusApplyButtonText["APPLY"] = "\u7533\u8BF7";
    LayoutStatusApplyButtonText["APPLYING"] = "\u7533\u8BF7\u4E2D";
    LayoutStatusApplyButtonText["CANCEL_APPLY"] = "\u53D6\u6D88\u7533\u8BF7";
    LayoutStatusApplyButtonText["IS_NOT_STARTED"] = "\u5C1A\u672A\u5F00\u59CB";
    LayoutStatusApplyButtonText["IS_ENDED"] = "\u5DF2\u7ED3\u675F";
    LayoutStatusApplyButtonText["IS_NOT_QUALIFIED"] = "\u672A\u8FBE\u6761\u4EF6";
    LayoutStatusApplyButtonText["IS_APPLIED"] = "\u5DF2\u7533\u8BF7";
})(LayoutStatusApplyButtonText || (LayoutStatusApplyButtonText = {}));
//# sourceMappingURL=LayoutStatusType.js.map